export default __webpack_public_path__ + "static/media/male_profile.9c396dcf.svg";